class SimpleInterpolation {
  constructor(data) {
    const xs = data.map((d) => d[0]);
    const ys = data.map((d) => d[1]);
    this.xs = xs;
    this.ys = ys;
  }

  at(x) {
    if (this.xs.indexOf(x) > -1) {
      return this.ys[this.xs.indexOf(x)];
    }
    if (this.xs[this.xs.length - 1] > x) {
      return Infinity;
    }
    for (let i = this.xs.length - 2; i >= 0; i -= 1) {
      if (this.xs[i] > x) {
        const q =
          this.ys[i + 1] +
          ((x - this.xs[i + 1]) * (this.ys[i] - this.ys[i + 1])) / (this.xs[i] - this.xs[i + 1]);
        return q;
      }
    }
    return Infinity;
  }
}

export default SimpleInterpolation;
